/* eslint-disable consistent-return */
import React, { useEffect, useState, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  cancelHotelBookingApi,
  getHotelBookingDetailsApi,
  // offlineHotelCancellation,
} from '../../../api/hotelApi';
import AppLoading from '../../../shared/components/app-loading/AppLoading';
import AppAlert from '../../../shared/components/app-alert/AppAlert';
import AppButton from '../../../shared/components/app-button/AppButton';
// import AppTextInput from '../../../shared/components/app-text-input/AppTextInput';
import AppModal from '../../../shared/components/app-modal/AppModal';
import './HotelCancellation.scss';
// import { getUserAgentId } from '../../../shared/helper-utils/localStorage';
// import { NAVIGATION_ROUTES } from '../../../shared/constants/Constants';

function HotelCancellation() {
  const navigate = useNavigate();
  const { transactionId } = useParams();
  const [voucher, setVoucher] = useState(undefined);
  const [alert, setAlert] = useState(undefined);
  const [isLoading, setLoading] = useState(false);
  // const [requestedBy, setRequestedBy] = useState('');
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showSuccessmodal, setShowSuccessModal] = useState(false);
  const cancellationRef = useRef(undefined);

  const cancellationPolicies = String(voucher?.canxpolicy_modified || '')
    .split('##')
    .map((policy) => policy.trim())
    .filter(Boolean);
  const leadGuest = [
    voucher?.leadpassenger_firstname,
    voucher?.leadpassenger_lastname,
  ]
    .filter(Boolean)
    .join(' ');

  const getHotelVoucherDetails = async () => {
    setLoading(true);
    const response = await getHotelBookingDetailsApi(transactionId);
    if (response?.HotelInvoice) {
      const data = response.HotelInvoice || {};
      setVoucher(data);
    } else {
      setAlert({
        variant: 'error',
        title: 'Hotel Voucher Details',
        description:
          response?.Root?.Message ||
          'Error while fetching hotel voucher details',
      });
    }
    setLoading(false);
  };

  useEffect(() => {
    getHotelVoucherDetails();
  }, []);

  const handleCancelBooking = () => {
    setShowConfirmModal(true);
  };

  const handleOnlineCancellation = async () => {
    setLoading(true);
    setShowConfirmModal(false);
    const res = await cancelHotelBookingApi(transactionId);
    if (res && res.Root?.Status === 'OK') {
      setAlert({
        variant: 'success',
        title: 'Hotel Cancellation',
        description: res.Root?.Message,
      });
      const { TransactionStatus } = res.Root;
      cancellationRef.current = TransactionStatus;
      setShowSuccessModal(true);
    } else {
      setAlert({
        variant: 'error',
        title: 'Hotel Cancellation',
        description: 'Failed to Cancel booking, please try again',
      });
    }
    setLoading(false);
  };

  return (
    <div className="hotel-cancellation-page">
      <AppLoading isLoading={isLoading} />
      {alert && (
        <AppAlert
          showIcon
          variant={alert.variant}
          title={alert.title}
          onHide={() => setAlert(undefined)}
          description={alert.description}
        />
      )}
      {voucher !== undefined && (
        <main className="hotel-cancellation">
          <header className="hotel-cancellation__page-heading">
            <div>
              <span className="hotel-cancellation__eyebrow">
                HOTEL RESERVATION
              </span>
              <h1>Review your booking</h1>
              <p>Check the details and cancellation terms before continuing.</p>
            </div>
            <span className="hotel-cancellation__status">
              {voucher.booking_status || 'Booking details'}
            </span>
          </header>

          <section className="hotel-cancellation__stay" aria-label="Hotel stay">
            <div className="hotel-cancellation__stay-heading">
              <div>
                <span className="hotel-cancellation__eyebrow">YOUR STAY</span>
                <h2>{voucher.hotel_name || 'Hotel booking'}</h2>
                <p>
                  {[voucher.hotel_address, voucher.hotel_cityreference]
                    .filter(Boolean)
                    .join(', ') || 'Address not available'}
                </p>
              </div>
              {voucher.hotel_rating && (
                <span className="hotel-cancellation__rating">
                  {voucher.hotel_rating} <span aria-hidden="true">★</span>
                </span>
              )}
            </div>

            <div className="hotel-cancellation__stay-facts">
              <div className="hotel-cancellation__fact">
                <span>Check-in</span>
                <strong>
                  {String(voucher.checkin_time || '-').split(' ')[0]}
                </strong>
              </div>
              <div className="hotel-cancellation__fact">
                <span>Check-out</span>
                <strong>
                  {String(voucher.checkout_time || '-').split(' ')[0]}
                </strong>
              </div>
              <div className="hotel-cancellation__fact">
                <span>Room</span>
                <strong>{voucher.room_type || '-'}</strong>
              </div>
              <div className="hotel-cancellation__fact">
                <span>Guests</span>
                <strong>
                  {voucher.noof_adults || 0} adults
                  {Number(voucher.noof_childs) > 0
                    ? `, ${voucher.noof_childs} children`
                    : ''}
                </strong>
              </div>
            </div>
          </section>

          <div className="hotel-cancellation__content-grid">
            <section className="hotel-cancellation__section">
              <div className="hotel-cancellation__section-heading">
                <span className="hotel-cancellation__section-index">01</span>
                <h2>Booking details</h2>
              </div>
              <dl className="hotel-cancellation__booking-details">
                <div>
                  <dt>File number</dt>
                  <dd>{voucher.confirmationno || '-'}</dd>
                </div>
                <div>
                  <dt>Booking ID</dt>
                  <dd>{voucher.txid || transactionId || '-'}</dd>
                </div>
                <div>
                  <dt>Supplier reference</dt>
                  <dd>{voucher.supplier_reference || '-'}</dd>
                </div>
                <div>
                  <dt>Voucher information</dt>
                  <dd>{voucher.voucherinfo || '-'}</dd>
                </div>
                <div>
                  <dt>Number of rooms</dt>
                  <dd>{voucher.noof_rooms || '-'}</dd>
                </div>
                <div>
                  <dt>Lead guest</dt>
                  <dd>{leadGuest || '-'}</dd>
                </div>
              </dl>
            </section>

            <section className="hotel-cancellation__section hotel-cancellation__policy">
              <div className="hotel-cancellation__section-heading">
                <span className="hotel-cancellation__section-index">02</span>
                <h2>Cancellation policy</h2>
              </div>
              {cancellationPolicies.length > 0 ? (
                <ol>
                  {cancellationPolicies.map((policy) => (
                    <li key={policy}>{policy}</li>
                  ))}
                </ol>
              ) : (
                <p className="hotel-cancellation__empty-policy">
                  No cancellation policy was provided for this booking.
                </p>
              )}
            </section>
          </div>

          <details className="hotel-cancellation__notes">
            <summary>Important information about your stay</summary>
            <ul>
              <li>
                The hotel may update the rooming list with guest names closer to
                arrival.
              </li>
              <li>
                Contact your booking office if you expect to arrive late. The
                hotel may release the room if you do not arrive on the first
                night.
              </li>
              <li>
                Special requests are not guaranteed. The hotel may also request
                a card imprint or deposit at check-in for incidentals.
              </li>
              <li>
                Please reconfirm your reservation with your agent before
                travelling.
              </li>
            </ul>
          </details>

          <footer className="hotel-cancellation__action">
            <div>
              <strong>Need to cancel this reservation?</strong>
              <span>Review the policy above before confirming.</span>
            </div>
            <AppButton
              btnText="Cancel booking"
              variant="red"
              className="hotel-cancellation__cancel-button"
              onClick={handleCancelBooking}
            />
          </footer>

          {showConfirmModal && (
            <AppModal
              modalTitle="Hotel Cancellation"
              showCloseButton
              onModalClose={() => setShowConfirmModal(false)}
            >
              <div className="text-center mb-2">
                Do you really want to Cancel the Booking
              </div>
              <div className="d-flex gap-2 justify-content-center">
                <AppButton
                  btnText="Yes"
                  onClick={handleOnlineCancellation}
                  className="px-5"
                />
                <AppButton
                  btnText="No"
                  variant="outlined"
                  className="px-5"
                  onClick={() => setShowConfirmModal(false)}
                />
              </div>
            </AppModal>
          )}
          {showSuccessmodal && (
            <AppModal modalTitle="" onModalClose={() => navigate('/hotel')}>
              <div className=" mb-2 d-flex flex-column gap-2 fs-14 ">
                <span>
                  Your Hotel Booking is cancelled and refund will be processed
                  shortly.
                </span>
                <span>
                  Booking ID: <b>{transactionId}</b>
                </span>
                <span>Status: Cancelled</span>
                <span>
                  Cancellation Reference: <b>{cancellationRef.current}</b>
                </span>
              </div>
              <div className="d-flex justify-content-center gap-3 mt-2">
                <AppButton btnText="Home" onClick={() => navigate('/hotel')} />
                <AppButton
                  btnText="My Bookings"
                  onClick={() =>
                    navigate('/my-bookings?transactionType=hotelBookings')
                  }
                />
              </div>
            </AppModal>
          )}
        </main>
      )}
    </div>
  );
}

export default HotelCancellation;
